var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"liens"},[_c('br'),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-12 is-paddingless"},[_c('my-vuetable')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }